// src/components/CreateProjectModal.tsx

import { Button, Form, Modal, message } from 'antd';
import type { Dayjs } from 'dayjs';
import React, { useId } from 'react';
import { useProjects } from '@/context/ProjectContext';
import { InteractionManager } from '@/SDK/InteractionManager';
import { runtimeConfig } from '@/utils/runtimeConfig';

// const { Link } = Typography;

interface FlightFormValues {
	flightNumber: string;
	airlineCode: string;
	aircraftType: string;
	departureDate: Dayjs;
	departureTime: Dayjs;
	origin: string;
	destination: string;
}

interface CreateProjectModalProps {
	open: boolean;
	onClose: () => void;
}

const CreateProjectModal: React.FC<CreateProjectModalProps> = ({
	open,
	onClose,
}) => {
	const [form] = Form.useForm<FlightFormValues>();
	// const [uploading, setUploading] = useState(false);
	const { refreshProjects } = useProjects();
	const im: InteractionManager = InteractionManager.getInstance();
	const fileInputId = React.useRef(`file-input-${Math.random()}`).current;

	const _handleConfirm = async () => {
		try {
			const values = await form.validateFields();
			console.log('Form values:', values);
			createProject(values);
			form.resetFields();
			onClose();
		} catch (errorInfo) {
			console.log('Validation Failed:', errorInfo);
		}
	};

	const createProject = async (values: any) => {
		const departureDateTimeString = `${values.departureDate}T${values.departureTime}:00Z`;

		const request = {
			Cargos: [
				{
					BinID: 0,
					Bulk: true,
					ChildWayBill: '',
					Contents: '',
					CreatedAt: departureDateTimeString,
					CustomerName: '',
					Destination: '',
					DimensionsHistory: [
						{
							Actor: 'string',
							Dimensions: {
								Height: 0,
								Length: 0,
								Width: 0,
							},
							ID: 'string',
							Timestamp: 'string',
						},
					],
					Events: [
						{
							Action: 'string',
							Actor: 'string',
							Timestamp: 'string',
						},
					],
					GroupID: 0,
					Locked: true,
					Origin: 'string',
					Priority: 0,
					SHC: ['string'],
					Stackable: true,
					Standby: true,
					Tiltable: true,
					UnitSystem: 'string',
					UpdatedAt: 'string',
					WayBill: 'string',
					Weight: 0,
					_id: 'string',
				},
			],
			ProjectData: {
				BinIDs: [0],
				CreatedAt: '',
				Metadata: {
					additionalProp1: 'string',
					additionalProp2: 'string',
					additionalProp3: 'string',
				},
				Name:
					'proj' +
					values.flightNumber +
					'_' +
					new Date().toLocaleDateString() +
					'_' +
					new Date().toLocaleTimeString(),
				UnplannedCargo: ['string'],
				UpdatedAt: 'string',
				_id: 0,
			},
		};
		im.API.createProject(request);
	};

	const handleImport = async (file: any) => {
		if (!file) {
			message.error('Please select a file first.');
			return;
		}
		try {
			const im = InteractionManager.getInstance();
			const response = runtimeConfig.isFedEx
				? await im.API.createProjectFromFedExLoadplan(file)
				: await im.API.createProjectAuto(file);
			if (response.Error) {
				onClose();
				console.error('Upload failed:', response);
				message.error(response.Payload);
				return;
			} else {
				onClose();
				refreshProjects();
				message.success('Bookings added successfully!');
			}
		} catch (err: any) {
			onClose();
			console.error('Unexpected error during upload:', err);
			message.error(`Error uploading file: ${err.message || 'Unknown error'}`);
			console.log(message);
		} finally {
			const input = document.getElementById(fileInputId) as HTMLInputElement;
			if (input) input.value = '';
		}
	};

	return (
		<Modal
			open={open}
			onCancel={onClose}
			footer={[
				<Button key="cancel" onClick={onClose}>
					cancel
				</Button>,
				// <Button key="confirm" type="primary" onClick={handleConfirm}>
				// 	Confirm
				// </Button>,
			]}
			title={
				<div
					style={{
						display: 'flex',
						justifyContent: 'space-between',
						alignItems: 'center',
						marginBottom: '40px',
					}}
				>
					<span>Create New Project</span>
				</div>
			}
		>
			<input
				type="file"
				accept=".json,.csv,.xlsx,.xls,.rtf"
				style={{ display: 'none' }}
				id={fileInputId}
				onChange={(e) => {
					const file = e.target.files?.[0];
					if (file) {
						handleImport(file);
					}
				}}
			/>
			<Button
				type="default"
				onClick={() => {
					const input = document.getElementById(
						fileInputId,
					) as HTMLInputElement | null;
					if (input) {
						input.value = ''; // 👈 reset to re-trigger on same file
						input.click();
					}
				}}
				style={{ marginBottom: '16px' }}
			>
				IMPORT AND AUTO CREATE
			</Button>
			{/*<Form<FlightFormValues>*/}
			{/*	form={form}*/}
			{/*	layout="horizontal"*/}
			{/*	labelCol={{ span: 8 }} // adjust width of label*/}
			{/*	wrapperCol={{ span: 16 }}*/}
			{/*>*/}
			{/*	<Form.Item*/}
			{/*		name="flightNumber"*/}
			{/*		label="Flight Number"*/}
			{/*		rules={[{ required: true, message: 'Please enter flight number' }]}*/}
			{/*	>*/}
			{/*		<Input placeholder="Enter flight number" />*/}
			{/*	</Form.Item>*/}
			{/*	<Form.Item*/}
			{/*		name="airlineCode"*/}
			{/*		label="Airline Code"*/}
			{/*		rules={[{ required: true, message: 'Please enter airline code' }]}*/}
			{/*	>*/}
			{/*		<Input placeholder="Enter airline code" />*/}
			{/*	</Form.Item>*/}
			{/*	/!* <Form.Item*/}
			{/*    name="aircraftType"*/}
			{/*    label="Aircraft Type"*/}
			{/*    rules={[{ required: true, message: "Please select aircraft type" }]}*/}
			{/*  >*/}
			{/*    <Select placeholder="Select aircraft type">*/}
			{/*      <Option value="A320">A320</Option>*/}
			{/*      <Option value="B737">B737</Option>*/}
			{/*      <Option value="B747">B747</Option>*/}
			{/*    </Select>*/}
			{/*  </Form.Item> *!/*/}
			{/*	<Form.Item*/}
			{/*		name="departureDate"*/}
			{/*		label="Departure Date"*/}
			{/*		rules={[{ required: true, message: 'Please select departure date' }]}*/}
			{/*	>*/}
			{/*		<DatePicker style={{ width: '100%' }} />*/}
			{/*	</Form.Item>*/}
			{/*	<Form.Item*/}
			{/*		name="departureTime"*/}
			{/*		label="Departure Time"*/}
			{/*		rules={[{ required: true, message: 'Please select departure time' }]}*/}
			{/*	>*/}
			{/*		<TimePicker style={{ width: '100%' }} format="HH:mm" />*/}
			{/*	</Form.Item>*/}
			{/*	<Form.Item*/}
			{/*		name="origin"*/}
			{/*		label="Origin"*/}
			{/*		rules={[{ required: true, message: 'Please enter origin' }]}*/}
			{/*	>*/}
			{/*		<Input placeholder="Enter origin" />*/}
			{/*	</Form.Item>*/}
			{/*	<Form.Item*/}
			{/*		name="destination"*/}
			{/*		label="Destination"*/}
			{/*		rules={[{ required: true, message: 'Please enter destination' }]}*/}
			{/*	>*/}
			{/*		<Input placeholder="Enter destination" />*/}
			{/*	</Form.Item>*/}
			{/*</Form>*/}
		</Modal>
	);
};

export default CreateProjectModal;
